module.exports = __webpack_public_path__ + "img/fpdtkd_white.adcabe43.png";